// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentPharmacy {
    static getAttributeTypeMap() {
        return BasicEnrollmentPharmacy.attributeTypeMap;
    }
}
BasicEnrollmentPharmacy.discriminator = undefined;
BasicEnrollmentPharmacy.additionalProperties = false;
BasicEnrollmentPharmacy.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "phoneNumberExtension",
        "baseName": "phoneNumberExtension",
        "type": "string"
    },
    {
        "name": "faxNumber",
        "baseName": "faxNumber",
        "type": "string"
    },
    {
        "name": "faxNumberExtension",
        "baseName": "faxNumberExtension",
        "type": "string"
    },
    {
        "name": "nabp",
        "baseName": "nabp",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "BasicEnrollmentAddress"
    },
];
//# sourceMappingURL=basicEnrollmentPharmacy.js.map